import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-loading',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './modal-loading.component.html',
  styleUrl: './modal-loading.component.scss'
})
export class ModalLoadingComponent {
  @Input() params: any;
  faSpinnerThird = faSpinnerThird

  readonly nzModalData: any = inject(NZ_MODAL_DATA);

  constructor(private modal: NzModalRef<any>) {
    this.params = this.nzModalData.params
  }
}
